/* Scoped custom element also initializes when Shopify reloads this section. */
if (!customElements.get('le-planer-landing')) {
  customElements.define('le-planer-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('[data-le-filters]')?.removeAttribute('hidden');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-le-filter]');
        if (button && this.contains(button)) this.filter(button.dataset.leFilter);
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-le-variant]')) this.updateVariant(event.target);
      });
      this.querySelectorAll('[data-le-variant]').forEach((select) => this.updateVariant(select));
    }
    filter(value) {
      this.querySelectorAll('[data-le-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.leFilter === value));
      });
      let count = 0;
      this.querySelectorAll('[data-le-mount]').forEach((card) => {
        card.hidden = value !== 'all' && !card.dataset.leMount.split(' ').includes(value);
        if (!card.hidden) count++;
      });
      const empty = this.querySelector('[data-le-empty]');
      if (empty) empty.hidden = count !== 0;
      const status = this.querySelector('[data-le-filter-status]');
      if (status) status.textContent = `${count} ${count === 1 ? 'light' : 'lights'} shown.`;
    }
    updateVariant(select) {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const card = select.closest('[data-le-card]');
      const button = card.querySelector('[type="submit"]');
      card.querySelector('[data-le-price]').textContent = option.dataset.price;
      const compare = card.querySelector('[data-le-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      button.disabled = option.dataset.available !== 'true';
      button.removeAttribute('aria-disabled');
      button.querySelector('span').textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
      const productForm = card.querySelector('product-form');
      if (productForm?.handleErrorMessage) productForm.handleErrorMessage();
      if (productForm) productForm.error = false;
      const image = card.querySelector('.product-img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.imageAlt;
      }
      card.querySelectorAll('[data-le-product-link]').forEach((link) => {
        if (option.dataset.url) link.href = option.dataset.url;
      });
      const quantity = card.querySelector('[name="quantity"]');
      const min = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      quantity.min = String(min);
      quantity.step = String(step);
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      const current = Number(quantity.value);
      if (!Number.isFinite(current) || current < min || (current - min) % step !== 0 || (quantity.max && current > Number(quantity.max))) {
        quantity.value = String(min);
      }
    }
  });
}
